import { FuuzeText, FuuzeTooltip, FuuzeTooltipDefaultTrigger } from '@fuuze/shared';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GoRss } from 'react-icons/go';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../../Hooks/use-user.hook';
import { useStore } from '../../../store/store';
import commonStyles from '../../../styles/common.module.css';
import { FuuzeNavLink } from '../fuuze-nav-link';

export function NavBarCreatorPodcastLink() {
  const { pathname } = useLocation();
  const podcastSelected = useStore(state => state.podcastSelected);
  const user = useUser();
  const { t } = useTranslation('components:leftNav', { keyPrefix: 'menuContent' });

  const podcast = useMemo(() => user.data?.getOwnedChannel(podcastSelected._id), [user.data, podcastSelected]);

  const Title = () => {
    if (!podcast) return null;

    if (user.data?.doesPodcastRequiresVerificationForInvitedUser(podcast._id)) {
      return (
        <div className={commonStyles.FlexRow} style={{ gap: 8, justifySelf: 'end' }}>
          <FuuzeText as='span'>{t('podcast')}</FuuzeText>
          <FuuzeTooltip render={<FuuzeTooltipDefaultTrigger severity='warning' text={null} />}>
            {t('needVerificationWarning')}
          </FuuzeTooltip>
        </div>
      );
    }

    if (!podcast.config.isPublished) {
      return (
        <div className={commonStyles.FlexRow} style={{ gap: 8, justifySelf: 'end' }}>
          <FuuzeText as='span'>{t('podcast')}</FuuzeText>
          <FuuzeTooltip render={<FuuzeTooltipDefaultTrigger severity='warning' text={null} />}>
            {t('podcastNotPublishedWarningTooltip')}
          </FuuzeTooltip>
        </div>
      );
    }

    return t('podcast');
  };

  return (
    <FuuzeNavLink
      path='/creator/podcast'
      active={pathname.includes('/creator/podcast')}
      Icon={GoRss}
      title={<Title />}
    />
  );
}
